import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../base_svg-icon/component';
import { Row, Col } from '../../util_grid/grid.js';
import Text from '@text';
import './styles/styles.scss';


/**
 * Displays trackinformation on the PDP.
 */
class PdpTracklist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTracklist: false,
    };
  }

  toggleTracklist = () => {
    this.setState(prevState =>  ({
      showTracklist: !prevState.showTracklist,
    }));
  };

  renderTracks = () => {
    const { type } = this.props;
    const { showTracklist } = this.state;
    const allDisks = this.props.trackData.slice(0);
    const showNumberOfDisks = 1;
    const showNumberOfTracks = 4;
    const hasMultipleDisks = allDisks.length > showNumberOfDisks;
    const disks = showTracklist ? allDisks : [allDisks.shift()];

    return disks.map((disk = [], disknr) => {
      const tracks = showTracklist ? disk : disk.slice(0, showNumberOfTracks);

      return (
        <Row key={`disk-${disknr}`}>
          <Col sm={12}>
            <div className={`pdp-tracklist-heading ${ !hasMultipleDisks && `hidden-xs`}`}>
              <h2 className="hidden-xs">Tracklist{hasMultipleDisks && `: ${type} ${disknr + 1}` }</h2>
            </div>
          </Col>
          <Col sm={12}>
            <ul>
              {tracks.map((item, i) => (
                <li key={`${disknr}-${i}`}>
                  <div>
                    <span className="trackno">{item.trackNo}</span>
                  </div>
                  <div className="trackcontent">
                    <span className="description">{item.description}</span>
                    <span className="artist">{item.artist}</span>
                  </div>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      );
    });
  };

  render() {
    const { showTracklist } = this.state;
    return (
      <div className="pdp-tracklist" data-test-id="pdp-tracklist">
        <div className="container">
          {this.renderTracks()}
          {!showTracklist && (
            <Row>
              <Col sm={8} smOffset={2}>
                <div className="toggle-tracks" onClick={this.toggleTracklist}>
                  <Icon
                    name="ico-arrow-circle-down"
                  />
                  <span><Text>pdp.menu.panel.tracklist.showAll</Text></span>
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    );
  }
}

PdpTracklist.propTypes = {
  /**
   * The type of medium, like: 'CD' or 'LP'
   */
  type: PropTypes.string,
  trackData: PropTypes.array,
};

export default PdpTracklist;
